<div class="share__button__container">
    <div class="icon__wrap">
        @for (icon of iconList; track $index) {
            <a [href]="icon.url+shareUrl" target="_blank" rel="noopener noreferrer">
                <img  [src]="icon.iconUrl" [alt]="icon.title">
            </a>
        }
       
    </div>
</div>